import { Colors, Fonts } from '../../theme';

export default {
  formText: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.font.primary.fakeBlack
  },
};
